import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SpotifyCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      toast.error('Spotify connection cancelled');
      navigate('/');
      return;
    }

    if (code) {
      handleCallback(code);
    } else {
      toast.error('Invalid callback');
      navigate('/');
    }
  }, [searchParams, navigate]);

  const handleCallback = async (code) => {
    try {
      // Pass the same callback URL that was used in the auth request
      const callbackUrl = `${window.location.origin}/spotify-callback`;
      await axios.post(`${API}/spotify/auth/callback`, null, {
        params: { code, redirect_uri: callbackUrl }
      });
      toast.success('Spotify connected successfully!');
      navigate('/');
    } catch (error) {
      console.error('Error handling Spotify callback:', error);
      toast.error('Failed to connect Spotify');
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="spotify-callback-page">
      <div className="text-center">
        <div className="text-2xl font-bold mb-4">Connecting to Spotify...</div>
        <div className="text-lg opacity-80">Please wait</div>
      </div>
    </div>
  );
}
